import Component from '../core/Component'
import { CMS, queries } from '../core/config'
import Flickity from 'flickity'
import { scrollToElement } from '../services/Scroll'
import enquire from 'enquire.js'
import { FlickityAutoHeightExtension } from '../plugins/FlickityAutoHeightExtension'
import {EMITS as MENU_EMITS} from './Menu'
import Scroll from '../services/Scroll'

export default class BarResponsiblitySlider extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            slider: null,
            menu: null,
            images: [],
            items: [],
            indicator: null
        }

        this.flickty = null
        this.menu = null
        this.disableAdaptiveHeight = false
        this.height = 0

        this.enquireHandler = null

        if (this.options.disableAdaptiveHeight) {
            this.enquireQuery = this.options.disableAdaptiveHeight in queries ? queries[this.options.disableAdaptiveHeight] : this.options.disableAdaptiveHeight
            this.enquireHandler = {
                match: () => this.flickityAutoHeightExt.deactivate(),
                unmatch: () => this.flickityAutoHeightExt.activate()
            }
        }

        this.index = null
        this.initializedWithHash = false
    }

    prepare() {
        if (CMS) {
            return
        }

        this.ref.items.forEach(item => item.id = `baritem-${item.id}`) //fake id aby neskakalo okno

        this.flickity = new Flickity(this.ref.slider, {
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true
        })

        this.flickityAutoHeightExt = new FlickityAutoHeightExtension(this.flickity)
        this.flickityAutoHeightExt.activate()

        this.flickity.on('change', this.handleSlideSelected)

        this.menu = Component.getFromElement(this.ref.menu)
        this.menu.on(MENU_EMITS.LINK_CLICKED, this.handleLinkClick)

        if (this.enquireHandler) {
            enquire.register(this.enquireQuery, this.enquireHandler)
        }

        const index = this.getInitialIndex()
        setTimeout(() => {
            this.select(index)

            if (this.initializedWithHash) {
                scrollToElement(this.element)
            }
        }, 0)

        Scroll.on('resize-x', this.handleResize)
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)

        if (this.enquireHandler) {
            enquire.unregister(this.enquireQuery, this.enquireHandler)
        }
    }

    handleLinkClick = data => {
        const index = data.index

        this.select(index)
    }

    handleSlideSelected = index => {
        this.select(index)
    }

    handleResize = () => {
        this.updateIndicator()
    }

    getInitialIndex() {
        const url = window.location.href
        const anchor = url.substring(url.indexOf("#"))
        const links = this.menu.getLinks()

        let index = links.findIndex(link => link.hash === anchor)

        if (!~index) {
            index = this.menu.getActiveLinkIndex()
        } else {
            this.initializedWithHash = true
        }

        if (index < 0) {
            index = 0
        }

        return index
    }

    select(index) {
        if (this.index === index) {
            return
        }

        this.index = index

        this.flickity.select(index)
        this.menu.select(index)

        this.ref.images.forEach(image => image.classList.remove('is-active'))
        this.ref.images[index].classList.add('is-active')

        this.updateIndicator()
    }

    updateIndicator() {
        const activeLinkRect = this.menu.getLinks()[this.index].getBoundingClientRect()
        const offsetParent = this.ref.indicator.offsetParent

        if (!offsetParent) {
            return
        }

        const elementRect = offsetParent.getBoundingClientRect()

        const top = activeLinkRect.top - elementRect.top
        const height = activeLinkRect.height

        this.ref.indicator.style.top = `${top}px`
        this.ref.indicator.style.height = `${height}px`
    }
}